// extracted by mini-css-extract-plugin
export default {"Wrapper":"Controls_Wrapper__th6Sk","Button":"Controls_Button__kFwCj"};